import { IStep } from '@chainlit/react-client'

import { aiCommands } from '../const'

const STRUCTURE_SYNC_COMMANDS = new Set<string>(Object.values(aiCommands))

export const flattenChainLitMessages = (
	messages: IStep[],
	condition: (node: IStep) => boolean,
) => {
	return messages.reduce((acc: IStep[], node) => {
		if (condition(node)) {
			acc.push(node)
		}

		if (node.steps?.length) {
			acc.push(...flattenChainLitMessages(node.steps, condition))
		}

		return acc
	}, [])
}

export const filterCommandMessages = (aiChatMessages: IStep[]) => {
	return aiChatMessages.filter((aiChatMessage) => !aiChatMessage.command)
}

/** All Chainlit steps that carry structure sync commands (any step type, including nested). */
export const flattenStructureCommandSteps = (messages: IStep[]) =>
	flattenChainLitMessages(
		messages,
		(m) => Boolean(m.command && STRUCTURE_SYNC_COMMANDS.has(m.command)),
	)

/** Matches the inline "Thinking…" state shown inside AiMessageAreaBubble. */
export const isAssistantThinkingMessage = (message: IStep): boolean =>
	message.name !== 'user' &&
	message.type === 'assistant_message' &&
	!message.isError &&
	!message.streaming &&
	!(message.output && message.output.trim().length > 0)
